export default {
  getConsumerEmpBoxesFlagGetters(state) {
    return state.consumerEmpBoxesFlag;
  },
  getInsuranceBoxFlagGetters(state) {
    return state.insuranceBoxFlag;
  },
  getpersonalizedFlagGetters(state) {
    return state.personalizedFlag;
  },
};
